import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
import {preinit} from 'react-dom';
preinit(parcelRequire.resolve("igRYP"), {as: 'style', precedence: 'default'});
let promise = Promise.all([parcelRequire.load("awzdE"), parcelRequire.load("kWrGa"), parcelRequire.load("akGdQ"), parcelRequire.load("5pEDO"), parcelRequire.load("67sSo"), parcelRequire.load("c6gg0"), parcelRequire.load("k9IXU"), parcelRequire.load("blC0m"), parcelRequire.load("3jckR"), parcelRequire.load("2nucT")]).then(() => {
let originalModule = parcelRequire("7ohac");
let resources = <>
  <link rel="modulepreload" href={parcelRequire.resolve("awzdE")} />
  <link rel="stylesheet" href={parcelRequire.resolve("igRYP")} precedence="default" />
  <link rel="modulepreload" href={parcelRequire.resolve("kWrGa")} />
  <link rel="modulepreload" href={parcelRequire.resolve("akGdQ")} />
  <link rel="modulepreload" href={parcelRequire.resolve("5pEDO")} />
  <link rel="modulepreload" href={parcelRequire.resolve("67sSo")} />
  <link rel="modulepreload" href={parcelRequire.resolve("c6gg0")} />
  <link rel="modulepreload" href={parcelRequire.resolve("k9IXU")} />
  <link rel="modulepreload" href={parcelRequire.resolve("blC0m")} />
  <link rel="modulepreload" href={parcelRequire.resolve("3jckR")} />
  <link rel="modulepreload" href={parcelRequire.resolve("2nucT")} />
</>;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
